export default function getOptions(language) {
    return {
        physics: {
            forceAtlas2Based: {
                gravitationalConstant: language === 'fr' ? -70 : -80,
                centralGravity: 0.001,
                springLength: 0,
                springConstant: 0.3,
                avoidOverlap: 0,
            },
            solver: 'forceAtlas2Based',
            stabilization: {
                iterations: 250,
            },
        },
        layout: {
            randomSeed: 1,
        },
    };
}
